import { useEffect, useState } from 'react';
import LoaderBlack from '../../img/common//Loader_360x360.gif';
import { SearchInput } from '../../features/home/components/SearchInput';
import RestaurantCard from '../../features/home/components/RestaurantCard';
import { useDispatch, useSelector } from 'react-redux';
import { useClearBasketDeliveryMutation, useSetRestaurantDistanceMutation, useUpdateBasketDeliveryMutation, useClearBasketMutation } from '../../services/basket.api';
import { useLazyFindAddressQuery, useLazyGetAddressDetailsQuery, useLazyGetRestaurantByNameQuery, useLazyGetRestaurantLatLongQuery, useLazyGetRestaurantByLatLongForDeliveryQuery, useLazyFindAddressLatLongQuery } from '../../services/restaurant.api';
import { setSessionSearchTerm, setSessionSearchResults, setSessionDeliveryAddress } from '../../store/sessionSlice';
import { resetMenuState, setInitialMenuRender } from '../../store/menuSlice';
import { isValidPostcode, extractPostcode } from '../../helpers/postcodeHelpers';
import { freshRelevance, gtmEvent } from '../../helpers/commonHelpers';
import { historyMW } from '../../helpers/routingHelpers';
import { useNavigate, useLocation, useMatch } from 'react-router-dom';

const DeliveryRestaurantSearchModal = ({ onClose, state }) => {
    const [loading, setLoading] = useState(false);
    const isDelivery = true;
    const navigate = useNavigate();
    const { delivery, numberOfItems } = useSelector(state => state.basket);
    const [prospectiveRestuarant, setProspectiveRestaurant] = useState(null);
    const { cmsConfig, inApp, restaurantId, searchTerm, isOriginalDeliveryJourney, optimizelyDeliveryJourney, searchResults, restaurant } = useSelector(state => state.session);
    const [hasUserTyped, setHasUserTyped] = useState(false);
    const [showSearchError, setShowSearchError] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [addressClickFromDropdown, setAddressClickFromDropdown] = useState(false);
    const [deliveryAddressPublicId, setDeliveryAddressPublicId] = useState(null);
    const [deliveryPostCode, setDeliveryPostcode] = useState(null);
    const dispatch = useDispatch();
    const [getRestaurantByName, { data, isLoading: restaurantByNameLoading, isFetching: restaurantByNameFetching, isUninitialized, isError: restaurantByNameIsError }, { lastArg }] = useLazyGetRestaurantByNameQuery();
    const [findAddress] = useLazyFindAddressQuery();
    const [findAddressLatLong] = useLazyFindAddressLatLongQuery();
    const [getAddressDetailsQuery] = useLazyGetAddressDetailsQuery();
    const [getRestaurantsByLatLongForDelivery] = useLazyGetRestaurantByLatLongForDeliveryQuery();
    const [getRestaurantByLocation, { isLoading: restaurantByLocationLoading, isFetching: restaurantByLatLongFetching }] = useLazyGetRestaurantLatLongQuery();
    const backgroundImage = cmsConfig?.backgroundConfig.backgroundImage
    const [restaurantsObtainedForAddress, setRestaurantsObtainedForAddress] = useState(false);
    const [updateBasketDelivery] = useUpdateBasketDeliveryMutation();
    const [clearBasketDelivery] = useClearBasketDeliveryMutation();
    const [setRestaurantDistance] = useSetRestaurantDistanceMutation();
    const [clearBasket] = useClearBasketMutation();
    const [showChangeToCollectionButton, setShowChangeToCollectionButton] = useState(false);

    const setSearchTerm = (newSearchTerm) => {
        dispatch(setSessionSearchTerm(newSearchTerm));
    };

    const setSearchResults = (SearchResults) => {
        dispatch(setSessionSearchResults(SearchResults));
    };

    const setDeliveryAddress = (isDelivery) => {
        if (isDelivery) {
            dispatch(setSessionDeliveryAddress(null));
        }
    };

    useEffect(() => {
        if (location?.search) {
            const queryParams = new URLSearchParams(location.search);
            const postcode = queryParams.get('postcode');
            if (!postcode) return;
            setSearchTerm(postcode);
        }
    }, []);

    useEffect(() => {
        if (restaurantByNameIsError) {
            setLoading(false);
            setSearchResults({ error: 'Please enter a valid postcode' });
            setShowSearchError(true);
        }
    }, [restaurantByNameIsError])

    useEffect(() => {
        if (!searchTerm.length) {
            setSearchResults(null);
            setLoading(false);
        }
        let lowerPathName = location?.pathname?.toLowerCase() ?? '';
        if (
            !restaurantByNameFetching
            && !restaurantByNameLoading
            && !restaurantByLocationLoading
            && !isUninitialized
            && data?.postcode?.toLowerCase() === searchTerm?.toLowerCase()
            && ('isDelivery' in lastArg && location?.pathname !== '/' ? lastArg.isDelivery
                && lowerPathName.includes('delivery') || !lastArg.isDelivery && lowerPathName.includes('collection') : true)
        ) {
            setLoading(false);
            handleSearchResult(data, data.isDelivery, false);
        }
    }, [searchTerm, data, restaurantByNameFetching, restaurantByNameLoading, restaurantByLocationLoading, isUninitialized]);

    const searchByText = async (isDelivery, searchTermOverride) => {
        setDeliveryAddress(isDelivery);
        searchTermOverride = searchTermOverride ? extractPostcode(searchTermOverride) : searchTermOverride;
        const term = searchTermOverride || searchTerm;
        if (!isDelivery && addresses?.length > 0) {
            setAddresses([]);
        }
        const trimmedTerm = term.trim();
        const isPostcodeValid = !isDelivery || isValidPostcode(trimmedTerm);

        if (!isOriginalDeliveryJourney || (trimmedTerm.length && isPostcodeValid)) {
            setLoading(true);
            if (delivery) {
                await clearBasketDelivery();
            }
            if (isDelivery && !isOriginalDeliveryJourney) {
                if (!term) {
                    setLoading(false);
                    setSearchResults({ error: 'Please enter a location' });
                    setShowSearchError(true);
                    return;
                }
                if (restaurantsObtainedForAddress) {
                    setSearchResults(null);
                    setRestaurantsObtainedForAddress(false);
                }
                var result = await findAddress({ query: term, isPostalCode: isPostcodeValid });
                if (result && result.data && result.data.results) {
                    setAddresses(result.data.results);
                } else {
                    setAddresses([]);
                }
                setLoading(false);
            }
            else {
                var result = await getRestaurantByName({ postCode: term, isDelivery }, false);
            }
        } else {
            setSearchResults(isDelivery ? { error: 'Please enter a valid postcode' } : null);
            setShowSearchError(true);
        }
    };

    const searchByLatLong = async (isDelivery) => {
        setDeliveryAddress(isDelivery);
        setHasUserTyped(false);
        const success = async ({ coords: { latitude, longitude } }) => {
            setLoading(true);
            if (isOriginalDeliveryJourney) {
                const result = await getRestaurantByLocation({ latitude, longitude, isDelivery });
                handleSearchResult(result.data, isDelivery, true);
            }
            else {
                if (restaurantsObtainedForAddress) {
                    setSearchResults(null);
                    setRestaurantsObtainedForAddress(false);
                }
                var result = await findAddressLatLong({ latitude, longitude });
                if (result && result.data && result.data.results) {
                    setAddresses(result.data.results);
                } else {
                    setAddresses([]);
                }
            }
            setLoading(false);

        };
        const error = (error) => {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    setSearchResults({ error: 'Please grant access to location services if you wish to search by location.' });
                    break;
                case error.POSITION_UNAVAILABLE:
                    setSearchResults({ error: 'Location information is unavailable.' });
                    break;
                case error.TIMEOUT:
                    setSearchResults({ error: 'The request to get user location timed out.' });
                    break;
                case error.UNKNOWN_ERROR:
                    setSearchResults({ error: 'An unknown error occurred.' });
                    break;
            }
            setShowSearchError(true);
            setLoading(false);
        };
        setLoading(true);
        if (inApp) {
            try {
                const result = await postMessageWithAwait({ type: 'GET_LOCATION' }, 'LATLONG');
                success({ coords: { latitude: result?.location?.latitude, longitude: result?.location?.longitude } });
            } catch (err) {
                setSearchResults({ error: 'Location information is unavailable. Please check your location permissions.' });
                setShowSearchError(true);
                setLoading(false);
            }
        } else {
            navigator.geolocation.getCurrentPosition(success, error);
        }
    };

    const handleSearchResult = async (result, isDelivery, latLongSearch, searchTermOverride) => {
        const params = {
            searchTerm: searchTermOverride ? searchTermOverride : searchTerm,
            searchResultsCount: result?.restaurants?.length ?? 0,
            searchDistanceToNearestRestaurant: result?.closestRestaurantDistance
        };
        gtmEvent(isDelivery ? 'Delivery Search' : 'Collection Search', params);
        if (!result || result.error) {
            gtmEvent('restaurant_search_error', params);
            setShowNotification({ heading: 'Oops!', description: 'Something went wrong, please try again.' });
            return;
        } else {
            setSearchResults(result);
            setSearchTerm(result.postcode);
            const isSuccessful = isDelivery ? result.canOrderDelivery : result.canOrderCollection;
            if (isSuccessful) {
                var restaurant = result?.restaurants.find(r => r.id === restaurantId);
                if (restaurant && !!restaurant.openingTimes?.isOpenForDelivery
                    && !restaurant.isDeliveryDisabled) {
                    handleContinue(restaurant, false);
                    onClose();
                }
            } else {
                const gaParams = {
                    searchTerm: searchTerm,
                    searchResultsCount: result?.restaurants?.length ?? 0,
                    searchDistanceToNearestRestaurant: result?.closestRestaurantDistance
                }

                if (searchTerm.length > 3 && isValidPostcode(searchTerm))
                    gaParams.searchTerm = searchTerm.trim().slice(0, searchTerm.length - 3)?.trim();  // Get the outward part of the postcode   

                if (result.restaurants && isDelivery) {
                    const noRestaurantsAvailableCurrently = result.restaurants?.some(r => r.isDeliveryHidden) ?? false;
                    if (noRestaurantsAvailableCurrently || !isDelivery)
                        historyMW.push('', isDelivery, navigate, { restaurants: result.restaurants, searchTerm, postCode: searchTerm, showClosedSites: true });
                    if (!noRestaurantsAvailableCurrently) {
                        gtmEvent('restaurant_search_no_delivery', gaParams);
                        setSearchResults({ error: 'We\'re sorry. Unfortunately we are not currently delivering to this postcode. Why not try collection instead?' });
                        setShowSearchError(true);
                        setShowChangeToCollectionButton(true);
                        setShowNotification({
                            heading: 'We’re Sorry!',
                            description: 'Unfortunately we are not currently delivering to this postcode. Why not try collection instead?',
                            redirectFn: async () => {
                                if (inApp) window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'SWITCH_JOURNEY_NAVBAR', journey: 'collection' }));
                                setSearchTerm(result.postcode);
                                searchByText(false, result.postcode);
                                historyMW.push('', false, navigate);
                            },
                            redirectCta: 'Order for collection'
                        });
                    }
                } else if (!isDelivery && result.restaurants?.length) {
                    if (result.restaurants.length) {
                        historyMW.push('', isDelivery, navigate, { restaurants: result.restaurants, searchTerm, postCode: searchTerm });
                    }
                } else {
                    gtmEvent(latLongSearch ? 'restaurant_search_no_location' : 'restaurant_search_no_restaurant', params);
                    setSearchResults({ error: 'We\'re sorry. Unfortunately we are not currently delivering to this postcode. Why not try collection instead?' });
                    setShowSearchError(true);
                    setShowChangeToCollectionButton(true);
                    setShowNotification({
                        heading: 'We’re Sorry!',
                        description: latLongSearch ? 'Sorry but we can\'t find your location. Please enter your postcode' : 'We have no restaurants within a 10 mile radius of your postcode.'
                    });
                }
            }
        }
    };

    const handleContinue = async (restaurant, switchToCollection, canProceed) => {
        const restaurantChanged = restaurant.id !== restaurantId;
        const haveItemsInBasket = numberOfItems > 0;
        if (restaurantChanged && haveItemsInBasket) {
            setShowChangeRestaurantModal(true);
        } else {
            handleRestaurantSelected(restaurant, switchToCollection);
        }
    };

    const handleRestaurantSelected = async (restaurant, switchToCollection) => {
        window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'CLEAR_BASKET' }));
        const isDelivery = !switchToCollection && !!restaurant.delivery;
        if (restaurant.id && restaurantId || switchToCollection) {
            if (restaurant.id !== restaurantId || switchToCollection) {
                dispatch(resetMenuState());
                if (isDelivery) {
                    await clearBasketDelivery();
                }
                await clearBasket();
            }
        }

        if (isDelivery) {
            const delivery = {
                ...restaurant,
                ...restaurant.delivery,
                fractional: restaurant.delivery.delivery_fee.fractional,
                currencyCode: restaurant.delivery.delivery_fee.currency_code,
                lat: restaurant.delivery.location.lat,
                lon: restaurant.delivery.location.lon,
                userPostcode: isOriginalDeliveryJourney && isValidPostcode(searchTerm) ? searchTerm : deliveryPostCode,
                address: searchTerm,
                deliveryQuote: restaurant.delivery,
                deliveryAddressId: deliveryAddressPublicId,
                isOriginalSearch: isOriginalDeliveryJourney,
                deliveryJourney: optimizelyDeliveryJourney
            };
            await updateBasketDelivery({ ...delivery, searchTerm, restaurantId: restaurant.id });
        } else {
            await setRestaurantDistance({ id: restaurant.id, distance: Math.round(restaurant.distance), searchTerm });
        }
        gtmEvent(isDelivery ? 'delivery_selected_restaurant' : 'collection_selected_restaurant');

        freshRelevance('pageChange', null, { 'sendBeacon': true });
        setTimeout(() => setSearchResults(false), 200);
        dispatch(setInitialMenuRender(true));
        historyMW.push(`/menu/${restaurant.id}`, isDelivery, navigate);
        if (switchToCollection) {
            onClose();
        }
    };

    const getAddressDetails = async (publicId) => {
        window['optimizely'] = window['optimizely'] || [];
        window['optimizely'].push({
            type: "event",
            eventName: "woosmap_address_details_api_call",
            tags: {
                revenue: 0,
                value: 0.00
            },
            properties: {
                count: 1
            }
        });
        var result = await getAddressDetailsQuery({ publicId });
        return result;
    }

    const updateAddressSearch = async (newSearchTerm, publicId) => {
        var result = await getAddressDetails(publicId);
        if (result && result.data?.postCode) {
            setDeliveryPostcode(result.data.postCode);
        }

        if (result && result.data && result.data.results && result.data.results.length > 0) {
            setAddresses(result.data.results);
        } else if (result && result.data) {
            setLoading(true);
            setAddresses([]);
            const latitude = result.data.latitude;
            const longitude = result.data.longitude;
            var response = await getRestaurantsByLatLongForDelivery({ latitude, longitude, address: newSearchTerm });
            setRestaurantsObtainedForAddress(true);
            setLoading(false);
            if (response.isSuccess && response.data) {
                handleSearchResult(response.data, response.data.isDelivery, false, newSearchTerm);
                setDeliveryAddressPublicId(publicId);
            }
        } else {
            setAddresses([]);
        }
    }

    useEffect(() => {
        if (hasUserTyped) {
            const timeoutId = setTimeout(async () => {
                if (searchTerm && searchTerm.length) {
                    searchByText(isDelivery);
                }
            }, 1000);
            return () => clearTimeout(timeoutId);
        } else if (searchTerm?.length && !searchResults && !addressClickFromDropdown) {
            searchByText(isDelivery);
        }
    }, [searchTerm, hasUserTyped]);

    useEffect(() => {
        const searchOnEnter = (e) => {
            if (e.key === 'Enter') {
                searchByText(isDelivery, searchTerm);
                const inputElement = document.getElementById('searchInput');
                if (inputElement) {
                    inputElement.blur();
                }
            }
        };
        window.addEventListener('keyup', searchOnEnter);
        return () => {
            window.removeEventListener('keyup', searchOnEnter);
        };
    }, [searchByText, searchTerm]);

    const searchProps = {
        isLoading: loading,
        handleRestaurantSelected: handleContinue,
        updateSearchTerm: (value) => {
            setHasUserTyped(true);
            setShowSearchError(false);
            setShowChangeToCollectionButton(false);
            setSearchTerm(value);
        },
        setSearchTermFromAddress: (value, publicId) => {
            setHasUserTyped(isOriginalDeliveryJourney ? true : false);
            setAddressClickFromDropdown(true);
            setShowSearchError(false);
            setShowChangeToCollectionButton(false);
            setSearchTerm(value);
            updateAddressSearch(value, publicId);
        }
    };
    return (
        <div className={`search-container-container ${searchResults?.restaurants?.length ? 'isSearching' : ''}`} style={{ width: '100%', marginTop: '0', marginBottom: '0' }}>
            <div className={`block pt-5 searchContainer ${backgroundImage ? 'has-image' : ''}`} style={{ width: '100%' }} ref={(el) => el && el.style.setProperty('padding', '0', 'important')}>
                <div className="columns is-flex-wrap-wrap">
                    <div className="column is-12 is-flex is-justify-content-center" style={{ paddingLeft: '1.5rem', paddingRight: '1.5rem' }}>
                        <div className="content" style={{ maxWidth: '640px', width: '100%', overflowY: 'auto', padding: 2 }}>
                            <SearchInput
                                label={!isOriginalDeliveryJourney ? 'Enter your location' : `Enter your postcode`}
                                errorMessage={searchResults?.error ? searchResults.error : ''}
                                valueCallback={searchProps.updateSearchTerm}
                                value={searchTerm}
                                onLocationClick={() => searchByLatLong(isDelivery)}
                                isError={showSearchError}
                                placeholder='Search location'
                                id='searchInput'
                                handleClick={() => searchByText(isDelivery, searchTerm)}
                                showIcon
                                showNotification={showNotification}
                                addresses={addresses}
                                addressValueCallback={searchProps.setSearchTermFromAddress}
                                errorMessageStyle={{ maxWidth: 'unset' }}
                            />
                        </div>
                    </div>

                    {showChangeToCollectionButton &&
                        <div className="delivery-address-check-button-container">
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    handleRestaurantSelected(restaurant, true);
                                    setProspectiveRestaurant(restaurant, true);
                                }}
                            >
                                <span>{'Order for collection'}</span>
                            </button>
                        </div>
                    }

                    {searchProps.isLoading &&
                        <div style={{ flexGrow: 1, alignContent: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center', paddingTop: '128px', paddingBottom: '128px' }}>
                            <img src={LoaderBlack} style={{ width: 64, height: 64 }} alt="logo" />
                        </div>
                    }

                    {!searchProps.isLoading && searchResults?.restaurants?.length ? <div className="column is-12  is-flex is-justify-content-center search-container-results">
                        <div className="content" style={{ maxWidth: '640px', width: '640px', maxHeight: '45vh' }}>
                            {searchResults?.restaurants?.filter(r => isDelivery ? true : !r.isCollectionHidden).map((restaurant, i) => (
                                <RestaurantCard id={'restaurantCard' + '-' + i} key={restaurant.id} restaurant={restaurant} handleRestaurantSelected={searchProps.handleRestaurantSelected} setProspectiveRestaurant={setProspectiveRestaurant} isDelivery={isDelivery} />
                            ))}
                            <div style={{ height: 10, width: 10 }} />
                        </div>
                    </div> : null}

                </div>
            </div>
            {/* The following is required to preload the spinner. */}
            <img src={LoaderBlack} style={{ width: 0, height: 0 }} alt="logo" />
        </div>
    );
};

export default DeliveryRestaurantSearchModal;